package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecurringAmountDto(
    @SerialName("amount") val amount: Double,
    @SerialName("iso_currency_code") val isoCurrencyCode: String? = null
)

@Serializable
data class RecurringTransactionStreamDto(
    @SerialName("stream_id") val streamId: String,
    @SerialName("account_id") val accountId: String,
    @SerialName("stream_type") val streamType: String,
    @SerialName("description") val description: String,
    @SerialName("merchant_name") val merchantName: String? = null,
    @SerialName("first_date") val firstDate: String,
    @SerialName("last_date") val lastDate: String,
    @SerialName("predicted_next_date") val predictedNextDate: String? = null,
    @SerialName("frequency") val frequency: String,
    @SerialName("transaction_ids") val transactionIds: List<String>,
    @SerialName("average_amount") val averageAmount: RecurringAmountDto,
    @SerialName("last_amount") val lastAmount: RecurringAmountDto,
    @SerialName("is_active") val isActive: Boolean,
    @SerialName("status") val status: String,
    @SerialName("personal_finance_category") val personalFinanceCategory: PersonalFinanceCategoryDto? = null
)

@Serializable
data class RecurringTransactionsResponse(
    @SerialName("recurring_streams") val recurringStreams: List<RecurringTransactionStreamDto>
)
